export default __webpack_public_path__ + "static/media/frames.1878fee5.png";